import React from 'react'
import styled from 'styled-components'
import 'font-awesome/css/font-awesome.css'
import media from '../styles/media'
import Menu from '../components/Menu'
import Language from '../components/Language'
import { FormattedMessage } from 'gatsby-plugin-intl'

const Container = styled.header`
  background-color: #404040;
`

const SocialMediaList = styled.ul`
  padding-left: 0;
  margin-left: -5px;
  margin-bottom: 0;
  list-style: none;
  text-align: right;
  & li {
    display: inline-block;
    font-family: 'Prelo-Book';
    font-size: 14px;
    padding: 15px 5px;
    position: relative;
  }
  ${media.sm`
    text-align: left;
  `};
`

const SocialMediaItem = styled.li`
  display: inline-block;
  padding-right: 10px;
  padding-left: 10px;
  .whiteHelp{
     color: #ffffff;
     display: inline-flex;
  }
  & a {
    color: #ffffff;
    display: inline-flex;
    & .fa {
      font-size: 24px;
      line-height: 24px;
      padding: 0px 10px;
    }
    :hover{
      color: #ffffff;
    }
  }
`

const Header = () => (
  <>
    <Container>
      <div className="row">
        <div className="col-xs-12">
          <SocialMediaList>
            <SocialMediaItem>
              <span className="whiteHelp">
                <i className="demo-icon icon-iconos-almesa-03">&#xe802;</i>
                <span className="visible-lg">
                  <FormattedMessage id="headerAyuda" />
                </span>
              </span>
            </SocialMediaItem>

            <SocialMediaItem>
              <Language />
            </SocialMediaItem>
          </SocialMediaList>
        </div>
      </div>
    </Container>

    <Menu />
  </>
)

export default Header
